import { mapState, mapMutations, mapActions } from 'vuex';
//import _ from 'lodash';

export const AddToFavoriteListMixin = {
  name: 'AddToFavoriteListMixin',

  computed: {
    ...mapState('Mixins/Bookmark', {
      ms_res_addToFavoriteList: 'res_addToFavoriteList',
    }),
  },

  methods: {
    ...mapMutations('Mixins/Bookmark', {
      mm_UPDATE_VIDEO_IN_FAVORITE_LIST: 'UPDATE_VIDEO_IN_FAVORITE_LIST',
    }),

    ...mapActions('Mixins/Bookmark', {
      ma_addToFavoriteList: 'addToFavoriteList',
    }),

    setCollectedInFavoriteList(video) {
      const { toCollect } = video;
      this.mm_UPDATE_VIDEO_IN_FAVORITE_LIST({
        video,
        payload: {
          collected: toCollect,
        },
      });
    },

    setIsDeletedInFavoriteList(video) {
      this.mm_UPDATE_VIDEO_IN_FAVORITE_LIST({
        video,
        payload: {
          isDeleted: true,
        },
      });
    },

    async addToFavoriteList(video) {
      await this.ma_addToFavoriteList(video);
      if (this.ms_res_addToFavoriteList) {
        this.setCollectedInFavoriteList(video);
      }
    },
  },
};
